import { render, staticRenderFns } from "./AutomationStatistics.vue?vue&type=template&id=97402982&scoped=true&"
import script from "./AutomationStatistics.vue?vue&type=script&lang=js&"
export * from "./AutomationStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AutomationStatistics.vue?vue&type=style&index=0&id=97402982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97402982",
  null
  
)

export default component.exports